import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from './modules/app';
import { IUserState } from './modules/user';
// import { IPermission } from './modules/permission';
import { ISessionManager } from './modules/session';
import { IRpiterTabsState } from './modules/routerTabs';

Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  user: IUserState;
  // permission: IPermission;
  sessions: ISessionManager;
  tabs: IRpiterTabsState;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
